<template>
  <div class="login">
    <form
        class="login__form"
        @keydown.enter="onFormEnter"
    >
      <div class="my-3 text-center font-weight-bolder">AFFY BOTS</div>
      <input
          class="hidden"
          type="password"
          autocomplete="new-password"
      />

      <b-form-input
          v-model="username"
          autocomplete="off"
          autofocus
          placeholder="Enter your username"
          :state="usernameState"
      ></b-form-input>

      <div class="d-flex align-items-center">
        <b-form-input
            class="mr-2"
            ref="passwordInput"
            v-model="password"
            autocomplete="off"
            placeholder="Enter your password"
            :type="passwordInputText ? 'text' : 'password'"
            :state="passwordState"
        />

        <b-form-checkbox
            v-model="passwordInputText"
        />
      </div>

      <b-button
          variant="success"
          @click="login"
      >
        login
      </b-button>
    </form>
  </div>
</template>

<script>
import {ApiService} from "@/api";

export default {
  name: 'AppLogin',
  data() {
    return {
      username: '',
      password: '',
      usernameState: null,
      passwordState: null,
      passwordInputText: false,
    }
  },
  methods: {
    onFormEnter () {
      if (!this.username) {
        this.usernameState = false
        this.showError()
        return
      }

      if (!this.password) {
        this.usernameState = true
        this.$refs['passwordInput'].focus()
        return;
      }

      this.login()

    },
    login() {
      this.passwordState = null
      this.usernameState = null

      if (!this.username || !this.password) {
        this.showError()

        if (!this.username) {
          this.usernameState = false
        }
        if (!this.password) {
          this.passwordState = false
        }
        return
      }

      ApiService.login({username: this.username, password: this.password})
          .then(({token, id}) => {
            this.setToken(token)
            localStorage.setItem('userId', id)
            this.username = ''
            this.password = ''
            this.$emit('loggedIn')
          })
          .catch(err => {
            if (err.response?.data?.message === 'Введен неверный пароль') {
              this.passwordState = false
              return
            }

            if (err.response?.data?.message === `Пользователь ${this.username} не найден`) {
              this.usernameState = false
              return
            }

            console.error(err)
          })
    },
    showError() {
      this.$bvToast.toast('Укажите username и пароль', {
        title: 'Error',
        autoHideDelay: 3000,
        variant: "danger"
      })
    },
    setToken(token) {
      localStorage.setItem('token', token)
    }
  }
}
</script>

<style>
.login {
  width: 100vw;
  height: 100vh;
  background-color: #d3f1bd;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login__form {
  padding: 30px;
  width: 500px;
  border: 1px solid #eee;
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
